/** @type {import('tailwindcss').Config} */
const brand = "#0112C2";

module.exports = {
  darkMode: "selector",
  theme: {
    extend: {
      screens: {
        xtall: { raw: "(min-height: 800px)" },
        tall: { raw: "(max-height: 799px)" },
        "m-height": { raw: "(max-height: 699px)" },
        short: { raw: "(max-height: 600px)" },
      },
      colors: {
        brand: {
          DEFAULT: brand,
          50: "#EBF1FF",
          100: "#CCDBFD",
          200: "#AEC3FC",
          300: "#92ABFA",
          400: "#4A66F4",
          500: "#2841ED",
          600: "#1026E0",
          700: brand,
          800: "#00057F",
          900: "#0F172A",
        },
        chart: {
          1: {
            default: "#2841ED",
            negative: "#D9F1FF",
          },
          2: {
            default: "#08BDBA",
            negative: "#D9F1FF",
          },
          3: {
            default: "#DFBF03",
            negative: "#D9F1FF",
          },
          4: {
            default: "#FF6B6B",
            negative: "#D9F1FF",
          },
          5: {
            default: "#DA348F",
            negative: "#D9F1FF",
          },
          6: {
            default: "#AEC3FC",
            negative: "#D9F1FF",
          },
          7: {
            default: "#28A138",
            negative: "#D9F1FF",
          },
          8: {
            default: "#F9A43F",
            negative: "#D9F1FF",
          },
          9: {
            default: "#B215DA",
            negative: "#D9F1FF",
          },
          10: {
            default: "#FFC777",
            negative: "#D9F1FF",
          },
          11: {
            default: "#007D79",
            negative: "#D9F1FF",
          },
          12: {
            default: "#99D7A5",
            negative: "#D9F1FF",
          },
        },
      },
      fontFamily: {
        "supera-black": "Supera Gothic Black",
        "supera-bold": "Supera Gothic Bold",
        "supera-extra-bold": "Supera Gothic Extra Bold",
        inter: "Inter",
      },
      boxShadow: {
        tooltip:
          "0px 8px 12px 0px rgba(12, 16, 20, 0.85), 0px 0px 1px 0px rgba(12, 16, 20, 0.81)",
        400: "0 12px 24px -6px rgba(12, 16, 20, 0.85), 0 0 1px 0 rgba(12, 16, 20, 0.81)",
        "search-bar": "0 0 8px 0 rgba(0, 0, 0, 0.25)",
      },
    },
  },
  plugins: [require("@tailwindcss/forms"), require("tailwind-scrollbar")],
  content: ["./src/**/*.{js,jsx,ts,tsx,html}"],
};
